import React from 'react';
import classNames from 'classnames';

import ItemIcon from './item-icon';

import styles from './toggle-item-button.scss';

const stateToIcon = {
  active: 'check',
  remove: 'minus',
  inactive: 'plus'
};

const ToggleItemButton = (props) => {
  return (
    <div
      className={classNames( styles.wrapper, styles[`wrapper-${props.iconState}`] )}
      onClick={props.toggleItem}
      onMouseOver={props.iconOver}
      onMouseOut={props.iconOut}
    >
      <ItemIcon symbol={stateToIcon[props.iconState]} />
    </div>
  );
};

ToggleItemButton.propTypes = {
  iconState: React.PropTypes.string,
  toggleItem: React.PropTypes.func,
  iconOver: React.PropTypes.func,
  iconOut: React.PropTypes.func
};

export default ToggleItemButton;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-list/toggle-item-button/toggle-item-button.jsx